// Service for the Attendance Dashboard "Mi equipo" — "Resumen del mes" "Marcajes"
// card (ASIS-5412 / REXASIS-011).
// GET /attendance/my-team/monthly-summary/marks-summary?cutoffCompanyId=1&monthlyCutId=1 —
// both query params are required: the company and monthly cutoff selected in the
// "Resumen del mes" filters panel (ASIS-5414).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyMarksSummaryOut,
  GetMyTeamMonthlyMarksSummaryParams,
  MyTeamMonthlyMarksSummary,
} from '../types/myTeamMonthlyMarksSummary.types';
import { mapMyTeamMonthlyMarksSummary } from '../mappers/myTeamMonthlyMarksSummary.mapper';


export class MyTeamMonthlyMarksSummaryService {
  async getSummary(
    params: GetMyTeamMonthlyMarksSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyMarksSummary>> {
    const query = buildQueryString({
      cutoffCompanyId: params.cutoffCompanyId,
      monthlyCutId: params.monthlyCutId,
    });
    const { ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_MARKS_SUMMARY } = API_CONFIG.ENDPOINTS;
    const endpoint = `${ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_MARKS_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetMyTeamMonthlyMarksSummaryOut>(
      endpoint, { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyMarksSummary(response.data) };
  }
}

export const myTeamMonthlyMarksSummaryService = new MyTeamMonthlyMarksSummaryService();
